var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { stroke: "none", strokeWidth: 1, fill: "currentColor", fillRule: "evenodd" },
            React.createElement("path", { d: "M32.086 12c2.145 0 3.898 1.751 3.914 3.914v16.17C36.015 34.247 34.288 36 32.143 36H16.172c-2.145.002-3.898-1.751-3.914-3.913V15.916c-.015-2.162 1.712-3.914 3.858-3.915L32.086 12zm.023 1.666H15.96a2.32 2.32 0 00-2.315 2.35v12.426c.01 1.297 1.061 2.35 2.349 2.348h16.15a2.321 2.321 0 002.314-2.35V16.015a2.36 2.36 0 00-2.348-2.348z" }),
            React.createElement("path", { d: "M28.726 23.201l-7.54 4.147A.8.8 0 0120 26.647v-8.294a.8.8 0 011.186-.701l7.54 4.147a.8.8 0 010 1.402z" }))));
});
